var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"j-start"},_vm._l((_vm.users),function(user){return _c('b-col',{attrs:{"cols":"12","lg":"6"}},[_c('div',{staticClass:"chart-card"},[_c('div',{staticClass:"header"},[_c('h4',[_vm._v("Ingresos de "+_vm._s(user.user.name))])]),_c('chart',{attrs:{"user_prop":user}})],1)])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }